<template>
  <div class="login-container">
    <el-form :model="ruleForm2" :rules="rules2" status-icon ref="ruleForm11" label-position="left" label-width="0px" class="demo-ruleForm login-page">
      <h3 class="title">CRM会员系统登录</h3>
      <el-form-item prop="username">
        <el-input type="text" v-model="ruleForm2.username" auto-complete="off" placeholder="用户名"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="ruleForm2.password" auto-complete="off" placeholder="密码" @keyup.enter.native="loginkeyup"></el-input>
      </el-form-item>
      <el-checkbox v-model="checked" class="rememberme">记住密码</el-checkbox>
      <el-link style="float: right" class="rememberme1" type="white" :underline="false" @click="retrievePWD">忘记密码</el-link>
      <el-form-item style="width: 100%">
        <el-button type="primary" style="width: 100%" :loading="loading" @click="login" :disabled="!conSubmit">登录</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :close-on-click-modal="false" width="20%" title="品牌选择" :visible.sync="changeBrandShow">
      <div style="display: flex; justify-content: center">
        <el-radio-group v-model="cpyNo">
          <div v-for="(item, index) in dataList" :key="index" style="padding: 10px 0">
            <el-radio :label="item.cpyNO">{{ item.companyName }}</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changecpyNo()">确 定</el-button>
        <el-button @click="changeBrandShow = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入vuex中的方法
// import store from 'vuex'
import { companyListApi, exchange } from "@/api/login";
let base64s = require("js-base64").Base64;
export default {
  name: "Login",
  data() {
    return {
      dataList: [],
      cpyNo: undefined,
      // 加载效果：
      loading: false,
      //   默认初始化
      ruleForm2: {
        username: "",
        password: "",
      },
      //   校验
      rules2: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 4, max: 24, message: "密码长度为 4 - 24", trigger: "blur" },
        ],
      },
      checked: false,
      changeBrandShow: false,
    };
  },
  computed: {
    conSubmit() {
      const { username, password } = this.ruleForm2;
      return Boolean(username && password);
    },
  },
  created() {
    if (localStorage.getItem("userInfo")) {
      this.ruleForm2 = JSON.parse(base64s.decode(localStorage.getItem("userInfo")));
      this.checked = true;
    }
    console.log(localStorage.getItem("userInfo"));
  },
  methods: {
    changecpyNo() {
      if (!this.cpyNo) {
        this.$message.error("请选择公司品牌");
        return;
      } else {
        exchange({
          cpyNO: this.cpyNo,
        }).then((res) => {
          // this.dataList = res.data;
          localStorage.setItem("token", res.access_token);
        });
        localStorage.setItem("cpyNo", this.cpyNo);
        if("6100"==this.cpyNo){
          localStorage.setItem("cpyName", "GIADA");
        }else if("6300"==this.cpyNo){
          localStorage.setItem("cpyName", "CURIEL");
        }else if("6400"==this.cpyNo){
          localStorage.setItem("cpyName", "COLOMBO");
        }
        this.changeBrandShow = false;
        this.$router.replace("/Layout");
      }
    },
    loginkeyup(e) {
      if (e.keyCode == 13) {
        this.login();
      }
    },
    getcompanyListApi() {
      companyListApi().then((res) => {
        this.dataList = res.data;
      });
    },
    login() {
      localStorage.removeItem("token");
      // 正在加载
      this.loading = true;
      this.$refs.ruleForm11.validate((valid) => {
        // console.log(valid,"登录");
        if (valid) {
          try {
            this.$store.dispatch("user/login", this.ruleForm2).then((res) => {
              if (res == false) {
                this.getcompanyListApi();
                this.changeBrandShow = true;
              }
            });
          } catch (error) {
            this.$messages.error("登录失败:账号或密码错误!");
          } finally {
            this.loading = false;
            if (this.checked) {
              localStorage.setItem("userInfo", base64s.encode(JSON.stringify(this.ruleForm2)));
            } else {
              localStorage.removeItem("userInfo");
            }
          }
        } else {
          return (this.loading = false);
        }
      });
    },
    //
    retrievePWD() {
      this.$router.push({ path: "/Retrievepasswordd" });
      console.log("找回密码");
    },
  },
};
</script>

<style lang="scss" scoped>
.rememberme1 {
  color: #606266 !important;
}
.login-container {
  width: 100%;
  height: 100%;
  background: #cbc68d;

  /* 登录框上下对齐 */
  display: flex;
  align-items: center;
}
.login-page {
  /* -webkit-border-radius: 5px; */
  border-radius: 5px;
  margin: 0 auto;
  width: 350px;
  padding: 20px 35px 35px 20px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
label.el-checkbox.rememberme {
  margin: 0px 0px 15px;
  text-align: left;
}
.el-input__inner {
  width: 100% !important;
}
</style>
